import { BlogPostStory, PostListItem, Meta } from '@/domains/post'

// Adapter function to transform Storyblok data to match your Post domain model
export function adaptStoryblokToPost(story: BlogPostStory): PostListItem {
  const { content, uuid, slug, created_at, published_at, tag_list = [] } = story

  return {
    id: uuid,
    // Add tags from tag_list
    tags: tag_list,
    title: content.title || '',
    publishedAt: content.custom_date ? content.custom_date : published_at ? published_at : created_at,
    createdAt: content.custom_date ?? created_at,
    slug: slug.replace('blog/', ''),
    author: {
      name: content.author_blog?.[0]?.name || '',
      image: content.author_blog?.[0]?.image || null,
      position: content.author_blog?.[0]?.position || '',
    },
    readTime: content.read_time || 0,

    // Media fields - transform from Storyblok asset to your structure
    previewImage: {
      id: content?.preview_image?.id || '',
      name: content?.preview_image?.title || '',
      url: content?.preview_image?.filename || '',
    },
  }
}

export const adaptStoryblokPagination = (total: number, perPage: number, currentPage: number): Meta['pagination'] => {
  const safeTotal = typeof total === 'number' ? total : 0

  return {
    page: currentPage,
    pageSize: perPage,
    pageCount: Math.ceil(total / perPage),
    total: safeTotal,
  }
}
